import { FC, useMemo } from 'react'

import {
  Text,
  BorderRadius4,
  CustomerLogo,
  GreyGrey10,
  GreyGrey70,
  GreyGrey90,
  Primary14ExtendedRegular,
  Primary14SemiBold,
  Center,
  Flex
} from '@sequencehq/core-components'
import { getLogoSrc } from 'Customer/index'
import { Customer } from '../../types'

export const QuoteReviewHeader: FC<{
  customer: Customer
  quoteNumber: string
  quoteTitle: string | undefined
}> = ({ customer, quoteNumber, quoteTitle }) => {
  const title = useMemo(() => quoteTitle ?? 'Untitled quote', [quoteTitle])

  return (
    <Flex alignItems="center" gap="8px">
      <Center
        borderRadius={BorderRadius4}
        overflow="hidden"
        boxSize="24px"
        background={GreyGrey10}
      >
        {customer && (
          <CustomerLogo
            src={getLogoSrc(customer)}
            size={24}
            fallbackSize={16}
          />
        )}
      </Center>
      <Text {...Primary14ExtendedRegular} color={GreyGrey70}>
        {quoteNumber}
      </Text>
      <Text {...Primary14SemiBold} color={GreyGrey90}>
        {title}
      </Text>
    </Flex>
  )
}
